module.exports = target => {
    const $navbar = document.querySelector('.navbar'); // Used for offsetting against bottom of navbar
	let $targets = [];

	// check if var target is a selector or DOM element.
	if (target.nodeType) {
		$targets.push(target);
	} else {
		$targets = document.querySelectorAll(target);
	}

	$targets.forEach($el => {
		const headerOffset = $navbar ? $navbar.clientHeight : 0;
		const elementPosition = $el.getBoundingClientRect().top;
		const offsetPosition = elementPosition + window.scrollY - headerOffset;
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	});
}